import { createComponent } from '@/helpers/alpine';
import prestashop from 'prestashop';

const ADD_TO_CART_SELECTOR = '.js-product-add-to-cart';
const SHIPPING_SELECTOR = '.js-product-shipping';
const PRODUCT_FORM_SELECTOR = '.js-product-actions form';
const QTY_INPUT_SELECTOR = '.js-product-qty-input';

type TProductRefreshResponse = {
    product_add_to_cart?: string;
    product_shipping?: string;
};

const Product = createComponent(() => ({
    setUpdatedProduct() {
        const needDynamicData = prestashop?.need_dynamic_data ?? false;
        if (needDynamicData !== true) {
            return;
        }

        prestashop.on('updatedProduct', (data: TProductRefreshResponse) => {
            this.setNode(ADD_TO_CART_SELECTOR, data?.product_add_to_cart);
            this.setNode(SHIPPING_SELECTOR, data?.product_shipping);
        });

        const shop = prestashop.shop as { is_location?: boolean } | undefined;
        if (!shop?.is_location) {
            this.refreshFromServer();
        }
    },

    async refreshFromServer() {
        const form = document.querySelector<HTMLFormElement>(
            PRODUCT_FORM_SELECTOR,
        );
        const url = prestashop?.urls?.pages?.product;
        if (!form || !url) {
            return;
        }

        const body = new FormData(form);
        body.set('ajax', '1');
        body.set('action', 'refresh');
        body.set(
            'quantity_wanted',
            form.querySelector<HTMLInputElement>(QTY_INPUT_SELECTOR)?.value ??
                '1',
        );

        const response = await fetch(url, {
            method: 'POST',
            body,
            headers: { Accept: 'application/json' },
        }).catch(() => null);

        if (!response?.ok) return;

        const data = (await response
            .json()
            .catch(() => null)) as TProductRefreshResponse | null;

        if (!data) return;

        this.setNode(ADD_TO_CART_SELECTOR, data.product_add_to_cart);
        this.setNode(SHIPPING_SELECTOR, data.product_shipping);
    },

    setNode(selector: string, html?: string) {
        if (!html) return;

        const div = document.createElement('div');
        div.innerHTML = html;

        const newNode = div.querySelector<HTMLElement>(selector);
        const current = document.querySelector<HTMLElement>(
            `#product ${selector}`,
        );

        if (!newNode || !current) return;

        const previousQuantity =
            current.querySelector<HTMLInputElement>(QTY_INPUT_SELECTOR)?.value;

        current.replaceWith(newNode);

        if (previousQuantity) {
            this.$nextTick(() => {
                const input =
                    newNode.querySelector<HTMLInputElement>(QTY_INPUT_SELECTOR);
                if (input && input.value !== previousQuantity) {
                    input.value = previousQuantity;
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        }
    },
}));

export { Product };
